import ShopNavBar from '../../components/ShopNavBar'
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import JobFileItem from '../../components/shop/JobFileItem';
import { useAuth } from '../../contexts/AuthContext';
import { formatTimeAgo } from '../../utils/utils';
import { completePrintJob } from '../../utils/printJobs';

const jobFiles = [
    {
        id: 1,
        name: "Full Doc-VCD.pdf",
        details: "A3, Colour, Double Sided, binding, 2mm, X1",
        pages: 20,
    },
    {
        id: 2,
        name: "Invoice_2025.pdf",
        details: "A4, Black & White, Single Sided",
        pages: 5,
    },
    {
        id: 3,
        name: "Portfolio_Final.pdf",
        details: "A4, Colour, Glossy Print",
        pages: 32,
    },
];

const ShopJobDetails = () => {
    const { currentUser } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const { job: initialJob } = location.state || {};
    const [job, setJob] = useState(initialJob);
    const [isSendingEmail, setIsSendingEmail] = useState(false);

    const handleMarkAsComplete = async () => {
        if (!job?.id) return;

        try {
            setIsSendingEmail(true);
            await completePrintJob(job.id);

            setJob((prev) => ({
                ...prev,
                status: "Completed"
            }));

        } catch (error) {
            console.error("Error updating job status:", error);
        } finally {
            setIsSendingEmail(false);
        }
    };

    const handleDownload = (file) => {
        try {
            if (!file?.url) return;

            const link = document.createElement("a");
            link.href = file.url;
            link.target = "_blank";

            // force download
            link.download = file.name || "download";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };


    return (
        <div className='bg-background min-h-full flex flex-col font-["Plus_Jakarta_Sans",sans-serif]'>
            <ShopNavBar type={currentUser?.type || "shop"} />
            <main className='flex-1 max-w-[1200px] mx-auto w-full px-[16px] md:px-[40px] py-[24px] md:py-[32px] pb-[80px] md:pb-[40px]'>
                <div>
                    <button
                        className="flex items-center gap-[8px] text-[#717182] hover:text-[#212326] transition-colors mb-[24px] group"
                        onClick={() => navigate(-1)}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-arrow-left w-[18px] h-[18px] group-hover:-translate-x-[2px] transition-transform">
                            <path d="m12 19-7-7 7-7"></path>
                            <path d="M19 12H5"></path>
                        </svg>
                        <span class="font-medium text-[14px]">
                            Back to Jobs
                        </span>
                    </button>
                    <div className="flex flex-col md:flex-row md:items-start justify-between gap-[16px] mb-[28px]"><div>
                        <h1 className="font-semibold text-[24px] md:text-[28px] text-[#212326] mb-[8px]">
                            Print Job Details
                        </h1>
                        <div className="flex items-center gap-[16px] flex-wrap">
                            <div className="flex items-center gap-[6px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="lucide lucide-user w-[14px] h-[14px] text-[#9298a0]">
                                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                                <span className="font-medium text-[14px] text-[#717182]">
                                    {job?.customer?.name || "Customer"}
                                </span>
                            </div>
                            <div className="flex items-center gap-[6px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="lucide lucide-mail w-[14px] h-[14px] text-[#9298a0]">
                                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                                </svg>
                                <span className="font-medium text-[14px] text-[#717182]">{job?.customer?.email || "Email"}</span>
                            </div>
                            <div className="flex items-center gap-[6px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="lucide lucide-clock w-[14px] h-[14px] text-[#9298a0]">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                                <span className="font-medium text-[14px] text-[#717182]">{formatTimeAgo(job?.createdAt)}</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="bg-white rounded-[14px] border border-[#e4e5e7] overflow-hidden">
                    <div className="px-[24px] py-[16px] border-b border-[#e4e5e7] bg-[#fafafa]">
                        <div className="flex items-center gap-[8px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-file-text w-[16px] h-[16px] text-[#ff5323]">
                                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                                <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                                <path d="M10 9H8"></path>
                                <path d="M16 13H8"></path>
                                <path d="M16 17H8"></path>
                            </svg>
                            <span className="font-semibold text-[14px] text-[#212326]">Files ({job.files.length})</span>
                        </div>
                    </div>
                    <div className="hidden md:grid grid-cols-[1fr_2fr_80px_120px] gap-[16px] px-[24px] py-[12px] border-b border-[#e4e5e7]">
                        <span className="font-semibold text-[12px] text-[#9298a0] uppercase tracking-[0.5px]">File Name</span>
                        <span className="font-semibold text-[12px] text-[#9298a0] uppercase tracking-[0.5px]">Specifications</span>
                        <span className="font-semibold text-[12px] text-[#9298a0] uppercase tracking-[0.5px] text-center">Pages</span>
                        <span className="font-semibold text-[12px] text-[#9298a0] uppercase tracking-[0.5px] text-center">Action</span>
                    </div>

                    {job.files.map((file) => (
                        <JobFileItem
                            key={file.id}
                            file={file}
                            onDownload={() => handleDownload(file)}
                        />
                    ))}
                </div>

                <div className="mt-[20px] flex items-center justify-end gap-[12px] bg-white rounded-[14px] border border-[#e4e5e7] p-[20px]">

                    {job.status === "Completed" ? (
                        <span className="flex items-center gap-[6px] px-[20px] py-[11px] rounded-[10px] bg-[#ecfdf5] text-[#059669] font-semibold text-[13px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                className="w-[16px] h-[16px]">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Job Completed
                        </span>
                    ) : (
                        <button
                            onClick={handleMarkAsComplete}
                            disabled={isSendingEmail}
                            className="flex items-center justify-center gap-[8px] px-[20px] py-[11px] rounded-[10px] bg-[#ff5323] text-white font-semibold text-[13px] hover:bg-[#e64a1f] transition-colors"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                className="w-[16px] h-[16px]">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            {isSendingEmail ? "Please wait..." : "Mark as Completed"}
                        </button>
                    )}

                </div>

            </main>
        </div >
    )
}

export default ShopJobDetails
